import React from "react";
import "../styles/Promo.scss";

export const Promo = () => {
        const getLastDayOfMonth = () => {
            const today = new Date();
            const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
            
            return new Intl.DateTimeFormat("es-ES", {
              day: "numeric",
              month: "long",
              year: "numeric",
            }).format(lastDay);
        };
  return (
    <div className="promoContainerMain d-flex justify-content-center align-items-center">
      <div className="row promoContainer d-flex justify-content-center align-items-center">
        <div className="textPromo col-md-12 d-flex justify-content-center align-items-center flex-column">
          <span className="textPromoFirst">
            "¡Contáctanos.&nbsp;
            <span className="textPromoSecond">
            Chatea con nuestro bot, resuelve tus dudas y agenda tu cita hoy mismo!"
            </span>
          </span>
          <span className="ofertaText">Oferta válida hasta el {getLastDayOfMonth()}. </span>
        </div>
      </div>
    </div>
  );
};

export default Promo;
